import React from 'react';
export function LoadingAnimation() {
  return <div className="flex flex-col items-center gap-6" data-id="element-154">
      <div className="relative w-16 h-16" data-id="element-155">
        <div className="absolute inset-0 rounded-full border-4 border-gray-200 dark:border-gray-700" data-id="element-156" />
        <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-blue-500 animate-spin" data-id="element-157" />
        <div className="absolute inset-2 rounded-full border-4 border-transparent border-t-purple-500 animate-spin" style={{
        animationDirection: 'reverse',
        animationDuration: '1s'
      }} data-id="element-158" />
      </div>
      <div className="text-sm font-medium text-gray-600 dark:text-gray-400" data-id="element-159">
        Cargando datos...
      </div>
    </div>;
}